import { InfinitePile, PileProps } from "~/utils";
import { Card, cardsDefRepository } from "./card";

export type InfiniteCardPileProps = {
  cardName: string;
} & PileProps<Card>;

export class InfiniteCardPile
  extends InfinitePile<Card>
  implements InfiniteCardPileProps
{
  cardName: string;

  constructor(props: InfiniteCardPileProps) {
    super(() => cardsDefRepository.fromName(props.cardName), props);
    this.cardName = props.cardName;
  }
}
